export function HuiTab() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            color: '@',
            active: '<',
            disabled: '<'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
               <button class="hui-tab-item"
                        ng-attr-tabindex="{{ $huiCtrl.active? 0: -1 }}"
                ng-class="['hui-' + ($huiCtrl.color || 'accent'),
                           $huiCtrl.active? 'active' : '']" ng-transclude>
               </button>
            `;
        }
    }
}




